// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './permission.js'

import Vue from 'vue'
import App from './App'
import router from './router'
import Cookies from 'js-cookie'
// element-ui
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import 'element-ui/lib/theme-chalk/index.css'
locale.el.pagination.goto = '跳至';
Vue.use(ElementUI, { locale })
// add vuex
import store from './store'
// vue-axios
import axios from 'axios'
import vueAxios from 'vue-axios'
Vue.use(vueAxios, axios);

// vue-lazyload
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1,
  // loading: require('./assets/images/logo_default.svg')
})

// vue-awesome-swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

// vue-video-player
import VideoPlayer from 'vue-video-player'
window.videojs = VideoPlayer.videojs
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
require('video.js/dist/lang/zh-CN.js')
Vue.use(VideoPlayer)

import tool from "./utils/tool";
Vue.use(tool);

// 基础样式
import '@/assets/style/reset.css'
// 重写element样式
import '@/assets/style/element.css'
// emoji样式
import '@/assets/style/emoji.css'

import '@/assets/style/common.css'

// 字符串解析和序列化字符串的库
import qs from "qs";
Vue.use(qs)

// 全局eventBus
window.eventBus = new Vue();

// 全局公共方法
import common from '@/components/common.vue'
import { prefixSrc, cutStr, getNumbers } from '@/utils/common'
import { emoji } from '@/utils/emoji.js'
Vue.prototype.COMMON = common;
Vue.prototype.$prefixSrc = prefixSrc
Vue.prototype.$cutStr = cutStr
Vue.prototype.$getNumbers = getNumbers
Vue.prototype.$emoji = emoji

// 注册全局组件
import CommonHeader from '@/components/header'
import CommonFooter from '@/components/footer'
import Pagination from "@/components/Pagination";


Vue.component("common-header", CommonHeader)
Vue.component("common-footer", CommonFooter)
Vue.component("pagination", Pagination)

window.$phoneInterval = ''; //短信验证码全局定时器变量
window.$emailInterval = ''; //邮箱验证码全局定时器变量

// 全局配置接口正式、测试域名
Vue.prototype.global = {};
if (process.env.NODE_ENV == 'production') { //production:正式global环境
  Vue.prototype.global.base_url = "https://www.yiihuu.cc"
} else { //development:本地测试环境
  Vue.prototype.global.base_url = "http://course-admin.yiihuu.com:81"
}

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js